<template>
    <div
        :data-cy="dataCy"
        v-html="markdown.render(source)"
    />
</template>

<script setup lang="ts">
import MarkdownIt, { type Options as MarkdownItOptions } from 'markdown-it'

const props = defineProps<{
    source: string
    dataCy?: string
    options?: MarkdownItOptions
    openLinksInNewTab?: boolean
}>()

const markdown = new MarkdownIt(props.options ?? {})

if (props.openLinksInNewTab) {
    const defaultRender =
        markdown.renderer.rules.link_open ??
        function (tokens, idx, options, _, self) {
            return self.renderToken(tokens, idx, options)
        }

    markdown.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        tokens[idx].attrSet('target', '_blank')

        return defaultRender(tokens, idx, options, env, self)
    }
}
</script>
